<mat-form-field appearance="legacy" style="height:35px;margin-left:10px;">
    <mat-label>Templates</mat-label>
    <mat-select [ngModel]="template">
        <mat-option *ngFor="let template of templates" (click)="selectTemplate(template)" [value]="template">{{ template.template }}</mat-option>
    </mat-select>
</mat-form-field>